<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9.74902 12.0005C9.74902 10.7579 10.7564 9.7505 11.999 9.7505C13.2417 9.7505 14.249 10.7579 14.249 12.0005C14.249 13.2431 13.2417 14.2505 11.999 14.2505C10.7564 14.2505 9.74902 13.2431 9.74902 12.0005Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.58425 3.23279C9.56467 -0.202594 14.4333 -0.202596 15.4137 3.23279C15.7175 4.29719 16.811 4.92855 17.8847 4.65942C21.35 3.79079 23.7843 8.00712 21.2994 10.5739C20.5295 11.3691 20.5295 12.6319 21.2994 13.4271C23.7843 15.9939 21.35 20.2102 17.8847 19.3416C16.811 19.0725 15.7175 19.7038 15.4137 20.7682C14.4333 24.2036 9.56467 24.2036 8.58426 20.7682C8.28049 19.7038 7.18694 19.0725 6.11326 19.3416C2.64792 20.2102 0.213622 15.9939 2.69854 13.4271C3.46846 12.6319 3.46846 11.3691 2.69854 10.5739C0.213623 8.00712 2.64792 3.79079 6.11326 4.65942C7.18694 4.92855 8.28049 4.29719 8.58425 3.23279ZM11.999 8.2505C9.92796 8.2505 8.24902 9.92944 8.24902 12.0005C8.24902 14.0716 9.92796 15.7505 11.999 15.7505C14.0701 15.7505 15.749 14.0716 15.749 12.0005C15.749 9.92944 14.0701 8.2505 11.999 8.2505Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  props: {
    color: {
      type: String,
      default: "white",
    },
  },
})
</script>

<style></style>
